import {
  cibFacebook,
  cibTwitter,
  cibLinkedin,
  cibFlickr,
  cibTumblr,
  cibXing,
  cibGithub,
  cibStackOverflow,
  cibYoutube,
  cibDribbble,
  cibInstagram,
  cibPinterest,
  cibVk,
  cibYahoo,
  cibBehance,
  cibReddit,
  cibVimeo,
  cibCcMastercard,
  cibCcVisa,
  cibStripe,
  cibPaypal,
  cibGooglePay,
  cibCcAmex
} from "@coreui/icons";
import { cifUs, cifBr, cifIn, cifFr, cifEs, cifPl } from "@coreui/icons";
import {
  cilArrowRight,
  cilArrowThickLeft,
  cilAccountLogout,
  cilApplications,
  cilBan,
  cilBarChart,
  cilBasket,
  cilBarcode,
  cilBell,
  cilBook,
  cilCalculator,
  cilCalendar,
  cilClipboard,
  cilCloudDownload,
  cilChartPie,
  cilCheck,
  cilChevronBottom,
  cilChevronCircleDownAlt,
  cilVerticalAlignBottom,
  cilChevronTop,
  cilCheckCircle,
  cilCommentSquare,
  cilColumns,
  cilViewColumn,
  cilCursor,
  cilDrop,
  cilDollar,
  cilEnvelopeClosed,
  cilEnvelopeOpen,
  cilEuro,
  cilExpandDown,
  cilGlobeAlt,
  cilGrid,
  cilFile,
  cilHome,
  cilIndustry,
  cilJustifyCenter,
  cilLaptop,
  cilLayers,
  cilLightbulb,
  cilList,
  cilLocationPin,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMoon,
  cilNotes,
  cilOptions,
  cilPencil,
  cilPeople,
  cilPuzzle,
  cilSettings,
  cilShieldAlt,
  cilSpeech,
  cilSpeedometer,
  cilStar,
  cilTask,
  cilUser,
  cilUserFemale,
  cilUserFollow,
  cilXCircle,
  cilArrowTop,
  cilArrowBottom,
  cilCaretLeft,
  cilCaretRight,
  cilPrint,
  cilCaretBottom,
  cilCaretTop,
  cilLibrary,
  cilPlus,
  cilClock,
  cilAsteriskCircle,
  cilTrash,
  cilCopy,
  cilWarning,
  cilReload,
  cilActionUndo
} from "@coreui/icons";

export const iconsSet = Object.assign(
  {},
  {
    cilArrowRight,
    cilArrowThickLeft,
    cilAccountLogout,
    cilApplications,
    cilBan,
    cilBarChart,
    cilBarcode,
    cilBasket,
    cilBell,
    cilBook,
    cilCalculator,
    cilCalendar,
    cilClipboard,
    cilCloudDownload,
    cilChartPie,
    cilCheck,
    cilChevronBottom,
    cilChevronTop,
    cilCheckCircle,
    cilCommentSquare,
    cilCursor,
    cilDrop,
    cilDollar,
    cilEnvelopeClosed,
    cilEnvelopeOpen,
    cilEuro,
    cilExpandDown,
    cilChevronCircleDownAlt,
    cilVerticalAlignBottom,
    cilGlobeAlt,
    cilGrid,
    cilFile,
    cilHome,
    cilColumns,
    cilViewColumn,
    cilIndustry,
    cilJustifyCenter,
    cilLaptop,
    cilLayers,
    cilLightbulb,
    cilList,
    cilLocationPin,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMoon,
    cilNotes,
    cilOptions,
    cilPencil,
    cilPeople,
    cilPuzzle,
    cilSettings,
    cilShieldAlt,
    cilSpeech,
    cilSpeedometer,
    cilStar,
    cilTask,
    cilUser,
    cilUserFemale,
    cilUserFollow,
    cilXCircle,
    cilArrowTop,
    cilArrowBottom,
    cilCaretLeft,
    cilCaretRight,
    cilPrint,
    cilCaretBottom,
    cilCaretTop,
    cilLibrary,
    cilPlus,
    cilClock,
    cilAsteriskCircle,
    cilTrash,
    cilCopy,
    cilWarning,
    cilReload,
    cilActionUndo
  },
  {
    cifUs,
    cifBr,
    cifIn,
    cifFr,
    cifEs,
    cifPl
  },
  {
    cibFacebook,
    cibTwitter,
    cibLinkedin,
    cibFlickr,
    cibTumblr,
    cibXing,
    cibGithub,
    cibStackOverflow,
    cibYoutube,
    cibDribbble,
    cibInstagram,
    cibPinterest,
    cibVk,
    cibYahoo,
    cibBehance,
    cibReddit,
    cibVimeo,
    cibCcMastercard,
    cibCcVisa,
    cibStripe,
    cibPaypal,
    cibGooglePay,
    cibCcAmex
  }
);
